import React from 'react';
import { Await } from '../../../components/Await';
import { useSanity } from '../../../lib/landingPage';
import { observer } from 'mobx-react-lite';
import { BlogPostsPage } from './BlogPostsPage';

export const categoriesQuery = `
    *[_type == "category"] {
        title,
        slug,
        color,
        "count": count(
            *[_type == "post" && type == 'post' && references(^._id)]
        )
    }
`;

const featuredPostQuery = `
    *[_type == "featuredPost"]{
        featuredPost-> {
            ...,
            imageRef->
        }
    }[0]
`;

export const BlogHomePage = observer(() => {
    const sanity = useSanity();
    return (
        <Await
            views={{
                featuredPost: sanity.asyncBlog(featuredPostQuery),
                categories: sanity.asyncBlog(categoriesQuery),
            }}
            resolved={BlogPostsPage}
            extra={{
                pageTitle: 'Mais conteúdos do blog',
            }}
        />
    );
});
